import { useColorModeValue } from "@chakra-ui/react"

/**
 * Shared chart layout values used across WMS analytics blocks.
 */
export const chartLayout = {
  height: "340px",
  margin: { top: 12, right: 20, bottom: 20, left: 8 },
  yAxisWidth: 80,
} as const

/**
 * Maps internal chart series keys to user-facing labels.
 */
export function getChartSeriesLabel(seriesKey: string) {
  switch (seriesKey) {
    case "rolling_avg":
      return "Średnia krocząca"
    case "price_netto":
      return "Cena netto (PZ)"
    case "pz_price":
      return "Cena zakupu (PZ)"
    case "production_cost":
      return "Koszty produkcji"
    case "manual_price":
      return "Ręczna zmiana ceny"
    default:
      return seriesKey
  }
}

/**
 * Returns color-mode aware tokens for chart primitives and tooltip chrome.
 */
export function useChartTheme() {
  return {
    gridStroke: useColorModeValue("#E2E8F0", "#2D3748"),
    axisStroke: useColorModeValue("#718096", "#A0AEC0"),
    tooltipBg: useColorModeValue("#FFFFFF", "#1A202C"),
    tooltipBorder: useColorModeValue("#CBD5E0", "#4A5568"),
    tooltipText: useColorModeValue("#1A202C", "#F7FAFC"),
    series: {
      price: "#2B6CB0", // Blue
      priceDot: "#2F855A",
      rollingAverage: "#D69E2E",
      priceGradientId: "purchasePriceGradient",
      productionCost: "#805AD5", // Purple
      manualPrice: "#DD6B20", // Orange
    },
  }
}
